<template>
  <div class="page-wrapper">
    <el-tabs v-model="activeName" v-if="loadStatus">
      <!-- tabList 渲染tab数据 -->
       <el-tab-pane v-for="item in tabList" :key="item.name" :label="item.label" :name="item.name">
        <component :is="tabNameMap[item.name]" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import pagePathMixin from '@/utils/page-path-mixin'
import AiMaterialsTab from './components/tabs/AiMaterialsTab.vue'
import StoreActivityTab from './components/tabs/StoreActivityTab.vue'
import { getPermitList } from '@/store/modules/permission'

export default {
  name: 'StoreDecorationImageManagement',
  components: {
    AiMaterialsTab,
    StoreActivityTab
  },
  mixins: [pagePathMixin],
  data () {
    return {
      activeName: 'ai',
      loadStatus: false
    }
  },
  computed: {
    permitList () {
      return getPermitList()
    },
    hasPermission1 () {
      return this.permitList.includes('ec-pc-new#AiMaterialsTab')
    },
    hasPermission2 () {
      return this.permitList.includes('ec-pc-new#StoreActivityTab')
    },
    tabList () {
      let arr = []
      if (this.hasPermission1) arr.push({ name: 'ai', label: 'AI素材' })
      if (this.hasPermission2) arr.push({ name: 'activity', label: '店铺活动图' })
      return arr
    },
    // tab name 和 组件名称映射
    tabNameMap () {
      return {
        ai: 'AiMaterialsTab',
        activity: 'StoreActivityTab'
      }
    }
  },
  watch: {
    // activeName 根据权限动态修正为当前可用的 tab
    tabList: {
      immediate: true,
      handler (val) {
        const currentExists = (val || []).some(item => item.name === this.activeName)
        if (!currentExists) {
          this.activeName = val && val.length ? val[0].name : ''
        }
      }
    }
  },
  mounted () {
    this.loadStatus = true
  },
}
</script>

<style lang="stylus" scoped>
.page-wrapper
  height calc(100vh - 70px)

  >>> .el-tabs__header
    margin 5px 5px 0
    padding 5px 10px
    background #fff
    border-radius 5px

  >>> .el-tabs__content
    padding 5px
</style>
